export default "__VITE_ASSET__BByGI$AH__"